/**
 * AdminDonationsPage — ABMHC site CMS + the donation records that came in
 * through the public portal.
 *
 * Records live here because a gift given offline (cash, bank transfer, mobile
 * money) has to be confirmed by an admin before it counts as money — card
 * gifts are confirmed by the payment gateway.
 */
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ABMHCSiteManager from '@/components/abmhc/ABMHCSiteManager';
import DonationRecordsPanel from '@/components/abmhc/DonationRecordsPanel';

const PORTAL_TENANT_ID = '69d63c2c39ded375827179d9';

const AdminDonationsPage = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="admin-donations-page">
      <Tabs defaultValue="site">
        <TabsList className="mb-4">
          <TabsTrigger value="site" data-testid="tab-donations-site">Public site</TabsTrigger>
          <TabsTrigger value="records" data-testid="tab-donations-records">Donation records</TabsTrigger>
        </TabsList>
        <TabsContent value="site">
          <ABMHCSiteManager />
        </TabsContent>
        <TabsContent value="records">
          <DonationRecordsPanel tenantId={PORTAL_TENANT_ID} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminDonationsPage;
